import React,{useRef, useState, useEffect} from "react";
import { Toast, ToastContainer} from "react-bootstrap";

import { X } from "@phosphor-icons/react";

class QuickNote extends React.Component {

	
	constructor(props) {
		
		super(props);
		
		this.state = {
			bg: "primary",
			setup: this.props.setup ? this.props.setup : {open:false}
		};
		
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	
	handleEnter(){
		
		this.updateStatus({
			bg:this.props.setup && this.props.setup.bg ? this.props.setup.bg : this.state.bg
		});
		
		
	}
	show(message, button){
		this.updateStatus({setup:{open:true, text:message, button:button}}	)
	}
	handleExit(){
	
	}
	handleClose(){
		
		this.updateStatus({setup:{open:false, text:''}});
	}


	render() {
		return (
			<ToastContainer position="bottom-end" className="mb-4 me-4 quicknote">
				<Toast show={this.state.setup.open} position="bottom-end" autohide={true} bg={this.state.bg} onEnter={(e)=>{this.handleEnter(e)}} onExit={(e)=>{this.handleExit(e)}} onClose={(e)=>{this.handleClose(e)}} delay={8000}>
					<Toast.Body className="text-light">
						<X size={16} className="mt-1" onClick={(e)=>{this.handleClose(e)}}  />
						{this.state.setup.button}
						{this.state.setup.text}
						
					</Toast.Body>
				</Toast>
			</ToastContainer>
		);
	}
}

export default QuickNote;